var map = {
	"./ja.svg": "./src/assets/img/flag/ja.svg",
	"./ko.svg": "./src/assets/img/flag/ko.svg",
	"./zh.svg": "./src/assets/img/flag/zh.svg",
	"./zh_round.svg": "./src/assets/img/flag/zh_round.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/flag sync recursive ^\\.\\/.*\\.svg$";